import isEmpty from 'lodash/isEmpty';
import React from 'react';

export const Separator = ({ className, children }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <span className="border-ui-hair-2 border-t flex-auto" />
      {!isEmpty(children) && <span className="mx-4 text-sm text-ui-4">{children}</span>}
      <span className="border-ui-hair-2 border-t flex-auto" />
    </div>
  );
};
